import e from "./TypesenseSearch.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const t = /* @__PURE__ */ o(e, [["__scopeId", "data-v-e40940ee"]]);
export {
  t as default
};
